<script lang="ts">
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import { Button } from '@atoms';
	import CurvedCircles from '@comp/gfx/CurvedCircles.svelte';
	import EyedCircle from '@comp/gfx/EyedCircle.svelte';
	import HalfCirles from '@comp/gfx/HalfCirles.svelte';

	const {
		description,
		slug,
		headline,
		illustration
	}: { description: string; slug: string; headline: string; illustration: string } = $props();
</script>

<article>
	<div class="top" use:EnterOnView={{ delay: 0.2 }}>
		<div class="graphic">
			{#if illustration === 'half'}
				<HalfCirles></HalfCirles>
			{:else if illustration === 'full'}
				<EyedCircle></EyedCircle>
			{:else}
				<CurvedCircles></CurvedCircles>
			{/if}
		</div>

		<h2 class="text:headline">{headline}</h2>
	</div>

	<div class="bottom" use:EnterOnView={{ delay: 0.35 }}>
		<p class="text:description">{description}</p>

		<Button href={`/ydelser/${slug}`}>Læs mere</Button>
	</div>
</article>

<style lang="scss">
	article {
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		width: 100%;
		height: 100%;
		padding: 28px;
		background-color: hsl(var(--color-backgroundMuted));
	}

	.graphic {
		aspect-ratio: 1/1;
	}

	h2 {
		padding-bottom: 40px;
		padding-top: 26px;
		max-width: 335px;
	}

	.bottom {
		display: flex;
		flex-direction: column;
		align-items: start;

		:global([data-button]) {
			&:hover {
				color: hsl(var(--color-backgroundMuted));
			}
		}
	}

	p {
		max-width: 365px;
		padding-bottom: 36px;
	}
</style>
